var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.276 20.676a.6.6 0 0 1 0 1.199H2.725a.6.6 0 1 1 0-1.2zm-2.32-18.551a.6.6 0 0 1 .6.6V9.68a7.557 7.557 0 1 1-15.112 0V2.725a.6.6 0 1 1 1.199 0V9.68a6.358 6.358 0 0 0 10.851 4.495 6.36 6.36 0 0 0 1.863-4.495V2.725a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgUnderline;